@if (dataVariableList) {
  <div class="grid form-group max-cont">
    <div class="col-12">
      <p-divider align="center">
        <span class="p-tag">{{ title }}</span>
      </p-divider>
      <table class="table" style="width: 100%; border-collapse: collapse; overflow: visible">
        @if (displayVar === true) {
          <thead>
            <tr>
              <th width="30%">{{ libCol_1 }}</th>
              <th [ngClass]="{ 'width=70%': btnUpdate === false, 'width=60%': btnUpdate === true }" class="table-header">
                {{ libCol_2 }}
                @if (btnUpdate === true) {
                  <p-button icon="pi pi-save right" pTooltip="{{'Save' | translate}}" (onClick)="update()" severity="primary" />
                }
              </th>
            </tr>
          </thead>
        }
        <tbody>
          @for (item of dataVariableList; track item; let i = $index) {
            @if (item.system === 'false' || item.visible === 1 || item.isActiv === 'true') {
              <tr>
                <td [ngClass]="{ separ: item.type === 'separator' }">
                  @if (item.name !== '&SeparationLine') {
                    <span pTooltip="{{item.name}}" showDelay="500" [autoHide]="true"tooltipPosition="top">
                      {{ item.Label }}
                    </span>
                  }
                  @if (item.name === '&SeparationLine' && item.Label === '&SeparationLine') {
                    <span>
                      &nbsp;
                    </span>
                  }
                  @if (item.name === '&SeparationLine' && item.Label !== '&SeparationLine') {
                    <span>
                      {{ item.Label }}
                    </span>
                  }
                </td>
                @switch (item.type) {
                  @case ('separator') {
                    <td class="separ">
                      {{ item.DefaultValue }}
                    </td>
                  }
                  @case ('Date') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-calendar
                        appendTo="body"
                        [(ngModel)]="item.value"
                        [disabled]="item.disabled || item.ReadOnly || visuMode === true"
                        [dateFormat]="'dd/mm/yy'"
                        [firstDayOfWeek]="firstDayOfWeek"
                        showButtonBar="true"
                        inputId="date_{{i}}"
                      ></p-calendar>
                    </td>
                  }
                  @case ('DateTime') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-calendar
                        appendTo="body"
                        [(ngModel)]="item.value"
                        [disabled]="item.disabled || item.ReadOnly || visuMode === true"
                        [dateFormat]="'dd/mm/yy'"
                        [firstDayOfWeek]="firstDayOfWeek"
                        showButtonBar="true"
                        inputId="calendar_{{i}}"
                      ></p-calendar>
                    </td>
                  }
                  @case ('Combo') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      @if (item.Editable === true) {
                        <p-autoComplete
                          [(ngModel)]="item.value"
                          [suggestions]="filtered"
                          (completeMethod)="filterItem($event, item)"
                          field="displayValue"
                          [dropdown]="visuMode === false"
                          [readonly]="item.ReadOnly ||visuMode === true"
                          placeholder="{{ item.Label }}"
                          (ngModelChange)="onSelectComplete(item.value, item, i)"
                          appendTo="body"
                          scrollHeight="30vh"
						              inputId="autoComplete_{{i}}"
                          >
                        </p-autoComplete>
                      }
                      @if (item.Editable === false) {
                        <p-dropdown
                          [showClear]="!item.ReadOnly && visuMode === false"
                          [readonly]="item.ReadOnly || visuMode === true"
                          [editable]="item.Editable"
                          appendTo="body"
                          [options]="item.comboValue"
                          [(ngModel)]="item.value"
                          placeholder="{{ item.Label }}"
                          optionLabel="displayValue"
                          [filter]="true"
                          filterBy="displayValue"
                          emptyFilterMessage="'No_Result' | translate"
                          class="size_cent"
                          scrollHeight="30vh"
                          inputId="dropdown_{{i}}"
                        ></p-dropdown>
                      }
                    </td>
                  }
                  @case ('ComboCustom') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-dropdown
                        [showClear]="!item.ReadOnly && visuMode === false"
                        [readonly]="item.ReadOnly || visuMode === true"
                        appendTo="body"
                        [options]="item.comboValue"
                        [(ngModel)]="item.value"
                        placeholder="{{ item.Label }}"
                        optionLabel="displayValue"
                        [filter]="true"
                        filterBy="displayValue"
                        emptyFilterMessage="'No_Result' | translate"
                        class="size_cent"
                        scrollHeight="30vh"
                        inputId="dropdown_{{i}}"
                      ></p-dropdown>
                    </td>
                  }
                  @case ('ListUsers') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-dropdown
                        [showClear]="!item.ReadOnly && visuMode === false"
                        [readonly]="item.ReadOnly || visuMode === true"
                        appendTo="body"
                        [options]="item.comboValue"
                        [(ngModel)]="item.value"
                        placeholder="{{ item.Label }}"
                        optionLabel="displayValue"
                        [filter]="true"
                        filterBy="displayValue"
                        emptyFilterMessage="'No_Result' | translate"
                        class="size_cent"
                        scrollHeight="30vh"
                        inputId="dropdown_{{i}}"
                      ></p-dropdown>
                    </td>
                  }
                  @case ('ListGroups') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-dropdown
                        [showClear]="!item.ReadOnly && visuMode === false"
                        [readonly]="item.ReadOnly || visuMode === true"
                        appendTo="body"
                        [options]="item.comboValue"
                        [(ngModel)]="item.value"
                        placeholder="{{ item.Label }}"
                        optionLabel="displayValue"
                        [filter]="true"
                        filterBy="displayValue"
                        emptyFilterMessage="'No_Result' | translate"
                        class="size_cent"
                        scrollHeight="30vh"
                        inputId="dropdown_{{i}}"
                      ></p-dropdown>
                    </td>
                  }
                  @case ('ListDB') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      @if (item.Editable === true) {
                        <p-autoComplete
                          [(ngModel)]="item.value"
                          [suggestions]="filtered"
                          (completeMethod)="filterItem($event, item)"
                          field="displayValue"
                          [dropdown]="visuMode === false"
                          [readonly]="item.ReadOnly || visuMode === true"
                          placeholder="{{ item.Label }}"
                          (ngModelChange)="onSelectComplete(item.value, item, i)"
                          appendTo="body"
                          [virtualScroll]="true"
                          [virtualScrollItemSize]="38"
                          scrollHeight="30vh"
                          inputId="autoComplete_{{i}}"
                        >
                        </p-autoComplete>
                      }
                      @if (item.Editable === false) {
                        <p-dropdown
                          [showClear]="!item.ReadOnly && visuMode === false"
                          [readonly]="item.ReadOnly || visuMode === true"
                          appendTo="body"
                          [options]="item.comboValue"
                          [(ngModel)]="item.value"
                          placeholder="{{ item.Label }}"
                          optionLabel="displayValue"
                          [filter]="true"
                          filterBy="displayValue"
                          emptyFilterMessage="'No_Result' | translate"
                          class="size_cent"
                          [virtualScroll]="true"
                          [virtualScrollItemSize]="38"
                          scrollHeight="30vh"
                          inputId="dropdown_{{i}}"
                        ></p-dropdown>
                      }
                    </td>
                  }
                  @case ('DynamicIndex') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-dropdown
                        [readonly]="item.ReadOnly || visuMode === true"
                        appendTo="body"
                        [options]="item.comboValue"
                        [(ngModel)]="item.value"
                        placeholder="{{ item.Label }}"
                        (onClick)="onClickCmb($event, item, i)"
                        (onChange)="onChange($event, item, i)"
                        optionLabel="displayValue"
                        class="size_cent"
                        scrollHeight="30vh"
                        inputId="dropdown_{{i}}"
                      ></p-dropdown>
                    </td>
                  }
                  @case ('String') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <input
                        [disabled]="item.ReadOnly || visuMode === true"
                        id="{{ item.name }}"
                        [(ngModel)]="item.value"
                        class="p-inputtext size_cent"
                        pInputText
                        type="text"
                        />
                    </td>
                  }
                  @case ('TextArea') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <textarea
                        [rows]="5"
                        [cols]="30"
                        [disabled]="item.ReadOnly || visuMode === true"
                        id="{{ item.name }}"
                        [(ngModel)]="item.value"
                        class="p-inputtext size_cent width-100"
                        pInputTextarea
                        >
                      </textarea>
                    </td>
                  }
                  @case ('Integer') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <input
                        [disabled]="item.ReadOnly || visuMode === true"
                        id="{{ item.name }}"
                        [(ngModel)]="item.value"
                        class="p-inputtext size_cent"
                        pInputText
                        type="number"
                        />
                    </td>
                  }
                  @case ('InputNumber') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-inputNumber
                        [disabled]="item.ReadOnly || visuMode === true"
                        [inputId]="item.name"
                        [(ngModel)]="item.value"
                        class="size_cent"
                        styleClass="size_cent"
                        inputStyleClass="size_cent"
                        mode="decimal"
                      >
                      </p-inputNumber>
                    </td>
                  }
                  @case ('InputCurrency') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-inputNumber
                        [disabled]="item.ReadOnly || visuMode === true"
                        [inputId]="item.name"
                        [(ngModel)]="item.value"
                        class="size_cent"
                        styleClass="size_cent"
                        inputStyleClass="size_cent"
                      >
                      </p-inputNumber>
                    </td>
                  }
                  @case ('Double') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <input
                        [disabled]="item.ReadOnly || visuMode === true"
                        id="{{ item.name }}"
                        [(ngModel)]="item.value"
                        class="p-inputtext size_cent"
                        pInputText
                        type="text"
                        pattern="{{ isFloat }}"
                        />
                    </td>
                  }
                  @case ('EditMask') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <input
                        [disabled]="item.ReadOnly || visuMode === true"
                        id="{{ item.name }}"
                        [(ngModel)]="item.value"
                        class="p-inputtext size_cent"
                        pInputText
                        type="text"
                        pattern="{{ item.pattern.regExpr }}"
                        />
                    </td>
                  }
                  @case ('Boolean') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-triStateCheckbox
                        [readonly]="item.ReadOnly || visuMode === true"
                        [(ngModel)]="item.value"
                        inputId="triStateCheckbox_{{i}}"
                        >
                      </p-triStateCheckbox>
                    </td>
                  }
                  @case ('MultiSelect') {
                    <td [ngClass]="{ readonly: item.ReadOnly, required: item.Required }">
                      <p-multiSelect
                        styleClass="min-w-full max-w-full w-30rem"
                        [showClear]="!item.ReadOnly && visuMode === false"
                        [readonly]="item.ReadOnly || visuMode === true"
                        appendTo="body"
                        [options]="item.comboValue"
                        [(ngModel)]="item.value"
                        placeholder="{{ item.Label }}"
                        optionLabel="displayValue"
                        [filter]="true"
                        filterBy="displayValue"
                        emptyFilterMessage="'No_Result' | translate"
                        display="chip"
						            inputId="multiSelect_{{i}}"
                        ></p-multiSelect >
                    </td>
                  }
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
}
